// tslint:disable:max-line-length

import React from 'react';

export const ObjectNotFound = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 25 24" {...props}>
      <path
        d="M23.375 21.75H23V1.5C23 0.703125 22.2969 0 21.5 0H3.5C2.65625 0 2 0.703125 2 1.5V21.75H1.57812C0.96875 21.75 0.5 22.2656 0.5 22.875C0.5 23.4375 0.96875 24 1.57812 24H23.375C23.9844 24 24.5 23.5312 24.5 22.9219C24.5 22.3594 23.9844 21.75 23.375 21.75ZM11.375 21.75H4.25V12.75H11.375V21.75ZM11.375 10.5H4.25V2.25H11.375V10.5ZM20.75 21.75H13.625V12.75H20.75V21.75ZM20.75 10.5H13.625V2.25H20.75V10.5Z"
        fill="#9A9DA1"
      />
    </svg>
  );
};
